export default __webpack_public_path__ + "static/media/DTSummary.673c88bd.png";